import { Columns3, GalleryHorizontalEnd, Layers3, MessageSquareQuote, Shapes } from "lucide-react";

export function BoardTypeIcon({ name, className = "h-5 w-5" }: { name: string; className?: string }) {
  const text = name.toLowerCase();
  const Icon = /compar|before|after/.test(text) ? Columns3
    : /ugc|creator|testimonial/.test(text) ? MessageSquareQuote
    : /ingredient|product|call.?out/.test(text) ? Shapes
    : /story|editorial|lifestyle/.test(text) ? GalleryHorizontalEnd : Layers3;
  return <Icon className={className} aria-hidden="true" />;
}